<template>
    <spinner-until :condition="optionsLoaded">
        <div class="log-list">
            <heading title="Log Records" tag="log-list-title"/>
            <data-table ref="dataTable"
                        :show-filters="true"
                        :show-pager="true"
                        :get-items="getEntries"
                        v-model="filters"
                        :fields="fields">
                <!-- template for custom columns -->
                <template v-slot:customField="slotProps">
                    <div v-if="slotProps.row.field.key === 'created'">
                        <timestamp :include-time="true"
                                   :include-year="true"
                                   :date="slotProps.row.item.created"/>
                    </div>
                </template>
            </data-table>
        </div>
    </spinner-until>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Page to list log entries
 */
export default Vue.extend({
    name: 'LogList',
    data () {
        return {
            modelTypes: [],
            actionTypes: [],
            fields: [
                { key: 'model', sortable: true, label: 'Model' },
                { key: 'action', sortable: true, label: 'Action' },
                { key: 'userEmail', sortable: true, label: 'User Email' },
                { key: 'text', sortable: true, label: 'Entry Text' },
                { key: 'created', sortable: true, label: 'Time' },
            ],
        }
    },
    computed: {
        filters () {
            return {
                model: {
                    field: 'model',
                    type: 'select',
                    value: null,
                    options: this.modelTypes,
                    label: 'Model Type'
                },
                action: {
                    field: 'action',
                    type: 'select',
                    value: null,
                    options: this.actionTypes,
                    label: 'Action Type'
                },
                email: { field: 'email', type: 'string', value: null, label: 'User Email' },
                after: { field: 'after', type: 'date', value: null, label: 'After' },
                before: { field: 'before', type: 'date', value: null, label: 'Before' },
            }
        },
        optionsLoaded () {
            return !!(this.modelTypes.length && this.actionTypes.length)
        }
    },
    created () {
        this.$api.getUserLogModelTypes(this)
            .then((types) => {
                this.modelTypes = _.map(types, (type) => {
                    return {
                        value: type, text: type || ''
                    }
                })
                this.modelTypes.push({ value: 'empty', text: 'empty' })
            })

        this.$api.getUserLogActionTypes(this)
            .then((types) => {
                this.actionTypes = _.map(types, (type) => {
                    return {
                        value: type, text: type || ''
                    }
                })
                this.actionTypes.push({ value: 'empty', text: 'empty' })
            })
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'user-log', this.filters, listParams)
        },
    },
})
</script>
